import type { ForgotPassword, ResetPassword, SignInCredential, SignInResponse, SignUpCredential } from '@/@types/auth'
import IdentityApiService from './IdentityApiService'

export async function apiSignIn(data: SignInCredential) {
   return IdentityApiService.fetchData<SignInResponse>({
      url: 'https://edefterapi.nes.com.tr/api/users/token', // ENVIRONMENT_DEGISKENI
      method: 'post',
      headers: {
         'Content-Type': 'application/json',
      },
      data: {
         userName: data.userName,
         password: data.password,
      },
   })
}

export async function apiSignUpAccountant(data: SignUpCredential) {
   return IdentityApiService.fetchData<string>({
      url: 'https://edefterapi.nes.com.tr/api/accountantmodules', // ENVIRONMENT_DEGISKENI
      method: 'post',
      data,
   })
}

export async function apiSignOut() {
   return IdentityApiService.fetchData({
      url: '/sign-out',
      method: 'post',
   })
}

export async function apiForgotPassword(data: ForgotPassword) {
   return IdentityApiService.fetchData({
      url: `https://edefterapi.nes.com.tr/api/users/reset-password-request?userName=${data.userName}`, // ENVIRONMENT_DEGISKENI
      method: 'get',
   })
}

export async function apiResetPassword(data: ResetPassword) {
   return IdentityApiService.fetchData({
      url: `https://edefterapi.nes.com.tr/api/users/reset-password`, // ENVIRONMENT_DEGISKENI
      method: 'post',
      data,
   })
}
